import { createClient } from '@supabase/supabase-js';

export const config = __WEB_CONFIG__;

/** Browser client: session in localStorage; picks up email-confirmation links (#access_token=…). */
export const supabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
